<template>
  <div class="row">
    <div class="col-12 mt-3">
      <PageTitle title="Sorteios dos lojistas" />
    </div>

    <div class="col-4 mt-3 mb-3">
      <label>Lojistas:</label>
      <v-select
        v-model="lojistaSelecionado"
        :options="lojistas"
        label="nome_fantasia"
        placeholder="-- Selecione um lojista --"
        @input="buscarLojista()"
      ></v-select>
    </div>

    <div class="col-12 mt-2" v-for="(results, index) in sorteios" :key="index">
      <div class="accordion-admin" role="tablist-admin">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab-admin">
            <b-button block v-b-toggle="'accordion-admin' + index" variant="primary">
              {{formatarNome(index)}}
            </b-button>
          </b-card-header>
          <b-collapse :id="'accordion-admin' + index" accordion="my-accordion-admin" role="tabpanel-admin">
            <b-card-body>

              <div class="col-12 mt-2" v-for="(sorteio, i) in results" :key="i">
                <div class="accordion" role="tablist">
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle="'accordion-' + i" :variant="sorteio.status == true ? 'success' : 'danger'">
                        Sorteio: <b>{{sorteio.name}}</b> - 
                        Início: <b>{{formatarData(sorteio.campaign_start)}}</b> -
                        Fim: <b>{{formatarData(sorteio.campaign_end)}}</b>
                      </b-button>
                    </b-card-header>
                    <b-collapse :id="'accordion-' + i" accordion="my-accordion" role="tabpanel">
                      <b-card-body>

                        <div class="row">
                          <div class="col-12 text-center">
                            <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                              DADOS DO SORTEIO
                            </h4>
                          </div>

                          <div class="col-12 text-right mb-2">
                            <button class="btn btn-primary mr-1" @click="getCupomPoints(sorteio.id)">
                              <i class="fas fa-search"></i>
                              Buscar cupom gerado
                            </button>

                            <button class="btn btn-dark mr-1" @click="getQrCodePoints(sorteio.id)">
                              <i class="fas fa-eye"></i>
                              Ver qr-code gerado
                            </button>
                          </div>

                          <div class="col-4 mb-2">
                            <label>Nome do sorteio:</label>
                            <input type="text" class="form-control" :value="sorteio.name" readonly>
                          </div>

                          <div class="col-8 mb-2">
                            <label>Descrição do sorteio:</label>
                            <input type="text" class="form-control" :value="sorteio.description" readonly>
                          </div>

                          <div class="col-3">
                            <label>Início do sorteio:</label>
                            <input type="text" class="form-control" :value="formatarData(sorteio.campaign_start)" readonly>
                          </div>

                          <div class="col-3">
                            <label>Fim do sorteio:</label>
                            <input type="text" class="form-control" :value="formatarData(sorteio.campaign_end)" readonly>
                          </div>

                          <div class="col-3">
                            <label>Valor do sorteio:</label>
                            <input
                              type="text"
                              class="form-control"
                              :value="'A cada '+formatarValor(sorteio.price)+' você ganha '+sorteio.points+ ' cupons'" 
                              readonly
                            >
                          </div>

                          <div class="col-3">
                            <label>Status:</label>
                            <button :class="sorteio.status == true ? 'statusAtivoBtn' : 'statusInativoBtn'">
                              {{ sorteio.status == true ? 'Ativo' : 'Inativo' }}
                            </button>
                          </div>
                          
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

    <b-modal
      title="Qr-code já gerados para o sorteio"
      size="xl"
      id="modal-show-qr-code-coupons"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <table class="table table-stripe table-bordered">
            <thead>
              <tr>
                <th>Cliente</th>
                <th class="text-center">Valor</th>
                <th class="text-center">Qtd. cupom</th>
                <th>Criado em</th>
                <th>Resgatado em</th>
                <th class="text-center">Status</th>
                <th class="text-center">Colaborador</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in qrcodeGerados" :key="i">
                <td>
                  <span v-if="item.user && item.user.client">
                    {{item.user.client.first_name}} {{item.user.client.last_name}}
                  </span>
                  <span v-else-if="item.user && item.user.company">
                    {{item.user.company.nome_fantasia}}
                  </span>
                  <span v-else-if="item.user && item.user.professional">
                    {{item.user.professional.name}}
                  </span>
                </td>
                <td class="text-center">{{formatarValor(item.money)}}</td>
                <td class="text-center">{{item.qtd}}</td>
                <td>{{item.created_at}}</td>
                <td>{{item.date_accepted}}</td>
                <td class="text-center">
                  <b-badge v-if="item.status == 1" variant="success">Resgatado</b-badge>
                  <b-badge v-else variant="danger">Não Resgatado</b-badge>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-dark btn-sm"
                    v-if="item.colaborador_id != null"
                    @click="getColaborador(item.colaborador_id)"
                  >
                    <i class="fas fa-eye"></i>
                  </button>

                  <span v-if="item.colaborador_id == null">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Cupons gerados para o sorteio"
      size="xl"
      id="modal-show-coupons-valid"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <table class="table table-stripe table-bordered">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>E-mail</th>
                <th class="text-center">Cupom</th>
                <th>Criado em</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in cuponsGerados" :key="i">
                <td>
                  <span v-if="item.user && item.user.client">
                    {{item.user.client.first_name}} {{item.user.client.last_name}}
                  </span>
                  <span v-else-if="item.user && item.user.company">
                    {{item.user.company.nome_fantasia}}
                  </span>
                  <span v-else-if="item.user && item.user.professional">
                    {{item.user.professional.name}}
                  </span>
                </td>
                <td>{{item.user.email}}</td>
                <td class="text-center">{{item.coupon}}</td>
                <td>{{item.created_at}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'LojistaMinhasRegras',
  mixins: [makeToast],
  components: {
    PageTitle,
    QrcodeVue
  },

  data() {
    return {
      lojistas: [],
      sorteios: [],
      cupons: [],
      qrcodeGerados: [],
      cuponsGerados: [],
      lojistaSelecionado: '',
      sorteioSelecionado: null,
      sorteioId: null,
      sorteio: {
        id: null,
        name: '',
        description: '',
        price: null,
        points: null,
        campaign_start: null,
        campaign_end: null,
        construp_user_id: null,
        status: false
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.get();
  },

  methods: {
    get(id = '') {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getRaffleCampaignAdmin', id)
        .then((response) => {
          this.sorteios = response.data.sorteios;
          this.lojistas = response.data.lojistas;
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar seus sorteio(s)!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    buscarLojista() {
      const id = this.lojistaSelecionado ? this.lojistaSelecionado.usuario_id : '';
      this.get(id)
    },
    formatarNome(id) {
      const usuario = this.lojistas.find(item => item.usuario_id == id);
      
      if(usuario.nome_fantasia) {
        return 'Lojista: '+usuario.nome_fantasia+' - Celular: '+usuario.celular;
      }

      return '-';
    },
    getColaborador(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getColaborador', id)
        .then((response) => {
          if(response.data.name) {
            const msg = 'Nome:'+response.data.name+' - Fone:'+response.data.phone +' - Cpf:'+response.data.cpf;
            this.makeToast('Sucesso', msg, 'primary');
          } else {
            this.makeToast('Opss', 'Erro ao buscar o colaborador', 'danger');
          }
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar o colaborador!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    getCupomPoints(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getCupomPoints', id)
        .then((response) => {
          if(response.data.length && response.data.length > 0) {
            this.cuponsGerados = response.data;
            this.$bvModal.show('modal-show-coupons-valid');
          } else {
            this.makeToast('Opss', 'Esse sorteio ainda não tem cupom!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar os cupons!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    getQrCodePoints(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getQrCodePoints', id)
        .then((response) => {
          if(response.data.length && response.data.length > 0) {
            this.qrcodeGerados = response.data;
            this.$bvModal.show('modal-show-qr-code-coupons');
          } else {
            this.makeToast('Opss', 'Esse sorteio ainda não tem cupom!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar os cupons!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    exportCsv() {
      const rows = this.cupons.map((item) => {
        return [
          `"${item.coupon || ''}"`
        ].join(',');
      });

      const csvData = [
        'cupom',
        ...rows,
      ].join('\n');

      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'cupons_sorteio.csv';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    formatarValor(valor) {
      let formatador = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      });

      return formatador.format(valor);
    },
    limparCamposSorteio() {
      this.sorteio.id = null;
      this.sorteio.name = '';
      this.sorteio.description = '';
      this.sorteio.price = null;
      this.sorteio.points = null;
      this.sorteio.campaign_start = null;
      this.sorteio.campaign_end = null;
      this.sorteio.construp_user_id = null;
      this.sorteio.status = false;
    },
    formatarData(dataHoraOriginal) {
      let [ano, mes, dia] = dataHoraOriginal.split('-');

      let dataHora = new Date(Date.UTC(ano, mes - 1, dia));
      dataHora.setUTCDate(dataHora.getUTCDate() + 1);

      let opcoesFormato = { day: '2-digit', month: '2-digit', year: 'numeric' };
      let dataHoraFormatada = new Intl.DateTimeFormat('pt-BR', opcoesFormato).format(dataHora);

      return dataHoraFormatada;
    },
  }
}
</script>

<style scoped>
.statusAtivo {
  background: #3bb53b;
  color: #FFF;
  padding: 0 10px;
  border-radius: 4px;
}
.statusInativo {
  background: #e71a1a;
  color: #FFF;
  border-radius: 4px;
}
.statusAtivoBtn {
  background: #3bb53b;
  color: #FFF;
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 4px;
}
.statusInativoBtn {
  background: #e71a1a;
  color: #FFF;
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 4px;
}
.couponList {
  line-height: 2.2;
  margin-right: 5px;
  border: 2px solid #222;
  border-radius: 4px;
  padding: 2px 5px;
  color: #004085;
  border-color: #b8daff;
  background-color: #cce5ff;
  transition: background-color 0.3s;
}
.highlight {
  background-color: yellow;
}
.finalHighlight {
  cursor: pointer;
  color: #fff;
  background-color: #3f3f3f;
  border-color: #000;
}
</style>